import { Component, Input } from '@angular/core';
import { ErrorCode } from '../../common/enums';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {

  errorCodeEnum = ErrorCode;

  @Input() errorCodes: ErrorCode[] = [];
}
